import { render } from "./NetworkForm.vue?vue&type=template&id=2468b878&ts=true"
import script from "./NetworkForm.vue?vue&type=script&lang=ts"
export * from "./NetworkForm.vue?vue&type=script&lang=ts"

import "./NetworkForm.vue?vue&type=style&index=0&id=2468b878&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__